import { render } from "./WorkAssignment.vue?vue&type=template&id=9e16a3ee&scoped=true"
import script from "./WorkAssignment.vue?vue&type=script&lang=js"
export * from "./WorkAssignment.vue?vue&type=script&lang=js"

import "./WorkAssignment.vue?vue&type=style&index=0&id=9e16a3ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e16a3ee"]])

export default __exports__